import React, { Component } from 'react'
import { Card, Button } from 'antd'
import { Chart, Interval, Tooltip, Axis, Coordinate } from 'bizcharts';
import './pie.less'

export default class Pie extends Component {
    state = {
        data: [
            { year: '2001', population: 41.8 },
            { year: '2002', population: 38 },
            { year: '2003', population: 33.7 },
            { year: '2004', population: 30.7 },
            { year: '2005', population: 25.8 },
            { year: '2006', population: 31.7 },
            { year: '2007', population: 33 },
            { year: '2008', population: 46 },
            { year: '2009', population: 38.3 },
            { year: '2010', population: 28 },
            { year: '2011', population: 42.5 },
            { year: '2012', population: 30.3 },
        ]
    }

    render() {
        const { data } = this.state
        return (
            <div>
                <Card >
                    <Button type="primary" onClick={this.update}>更新數據</Button>
                </Card>
                <Card title='Bizcharts圖'>
                    <Chart height={400} data={data} autoFit>
                        <Coordinate type="polar" innerRadius={0.2} />
                        <Axis visible={false} />
                        <Tooltip showTitle={false} />
                        <Interval
                            position="year*population"
                            adjust="stack"
                            color="year"
                            element-highlight
                            style={{
                                lineWidth: 1,
                                stroke: '#fff',
                            }}
                            label={['year', {
                                offset: -15,
                            }]}
                        />
                    </Chart>
                </Card>
            </div>
        )
    }
}